import { createUsersMeOffHourSelector } from "./createUsersMeOffHourSelector";
import { RootState } from "@/store/store";
export const duplicateMeOffHoursLoadingSelector = (
  state: RootState,
  id: string,
) => {
  return createUsersMeOffHourSelector(id)(state)?.isLoading;
};
